import { Component } from "react";
import { TableColumn } from "react-data-table-component";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";


import { loadFromLocalStorage } from "../../Common/Validation/LocalStorage";
import DataGrid from "../../Components/DataGrid/DataGrid";
import { ShowAlert } from "../../Components/ShowAlert";
import Form433AReviewService from "../../Services/Form433AReviewService";
const MySwal = withReactContent(Swal);

export interface IEvidence {
    evidence: string;
}

interface IEvidenceProps {
    userId: string;
    onPopupClose?: () => void
}
interface IEvidenceState {
    accessToken: string,
    evidenceList: IEvidence[];
}

class EvidenceList extends Component<IEvidenceProps, IEvidenceState> {

    constructor(props: IEvidenceProps) {
        super(props);
        this.state = {
            accessToken: '',
            evidenceList: []
        }
    }

    async componentDidMount() {
        ///... check token in local storage
        const accesstoken = await loadFromLocalStorage('accessToken');
        ///... if available get user details otherwise re-direct to login page
        if (accesstoken) {
            this.setState({
                accessToken: accesstoken.toString()
            }, () => {
                this.getUserEvidenceList()
            });
        }
        else {
            localStorage.clear();
            window.location.href = '/'
        }
    }

    getUserEvidenceList = () => {
        Form433AReviewService.getUserEvidenceList({ userId: this.props.userId }, this.state.accessToken).then((r) => {
            if (r.ok) {
                r.json().then(resp => {
                    this.setState({ evidenceList: resp });
                }, () => {
                    ///... post execution once state is set
                }).catch(err => {
                    Swal.fire("Error", err.message ? err.message : 'Failed due to technical difficulties', "error");
                });
            }
        });
    }

    private evidenceColumns: TableColumn<IEvidence>[] = [
        {
            name: 'S.No',
            cell: (row: IEvidence, index: number) => <div>{index + 1}</div>,
            width: '90px',
            center: true,
        },
        {
            name: 'Evidence',
            selector: row => row.evidence,
            width: '300px',
            center: true
        },
        {
            name: 'Documents',
            cell: (row: IEvidence) => (
                <button
                    className='view-documents-btn'
                    onClick={(event) => {
                        this.downloadFile(row.evidence);
                    }}>
                    Download
                </button>
            ),
            allowOverflow: false,
            button: true,
            width: '200px',
            center: true
        }
    ];

    downloadFile(evidence: string) {
        const downloadData = {
            userId: this.props.userId,
            evidenceName: evidence
        };

        Form433AReviewService.downloadEvidence(downloadData, this.state.accessToken).then((response) => {
            if (response.ok) {
                response.json().then(data => {
                    if (data && data.body) {
                        // Handle different response formats
                        let base64Data = data.body;

                        if (base64Data && typeof base64Data === 'string') {
                            try {
                                ///... Clean the base64 string - remove any whitespace and ensure it's properly formatted
                                base64Data = base64Data.replace(/\s/g, '');

                                ///... Convert base64 to blob
                                const byteCharacters = atob(base64Data);
                                const byteNumbers = new Array(byteCharacters.length);
                                for (let i = 0; i < byteCharacters.length; i++) {
                                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                                }
                                const byteArray = new Uint8Array(byteNumbers);
                                const blob = new Blob([byteArray], { type: 'application/pdf' });


                                // Create blob link to download
                                const url = window.URL.createObjectURL(blob);
                                const link = document.createElement('a');
                                link.href = url;
                                link.download = evidence + '.pdf';

                                // Append to html link element page
                                document.body.appendChild(link);

                                // Start download
                                link.click();

                                // Clean up and remove the link
                                link.parentNode?.removeChild(link);
                                window.URL.revokeObjectURL(url);

                            } catch (error) {

                            }
                        } else {
                            ShowAlert("", "There is no document available to download.", "error");
                        }
                    }
                    else {
                        ShowAlert("", "There is no document available to download.", "error");
                    }
                });
            } else {
                ShowAlert("", "There is no document available to download.", "error");
            }
        }).catch((err: any) => {

        });
    }

    render() {
        return (
            <DataGrid
                columns={this.evidenceColumns}
                data={this.state.evidenceList}
                pagination={false}
            />
        );
    }

}

export default EvidenceList;